export function showFindYourDoctorSection() {
  if (process.env.REACT_APP_SHOW_FIND_YOUR_DOCTOR_SECTION === undefined)
    return true;
  if (
    process.env.REACT_APP_SHOW_FIND_YOUR_DOCTOR_SECTION?.toUpperCase() ===
    "TRUE"
  )
    return true;
  return false;
}
